import { Feature } from 'src/enums/Features';
import { UserFeatureStatusEnum } from 'src/enums/UserFeatureStatusEnum';
import { useUserFeatureStatus } from 'src/queries/userFeatureStatus';

export function useActiveFeature(feature: Feature) {
  const { data: userFeatures = {} } = useUserFeatureStatus();
  return userFeatures[feature] === UserFeatureStatusEnum.On;
}
